// Centralized brand assets so we change them in one place.
// Logo oficial Sollute (Marca Vertical conforme Manual de Identidade).
export const LOGO_URL = "/sollute-logo.png";
export const BRAND_NAME = "Sollute Ocupacional";
export const PRODUCT_NAME = "NR-01 · Psicossocial";
